const initDetailDelete = (form) => {
    const deleteOverlayTriggers = form.querySelectorAll('.js-overlay-trigger');
    const deleteOverlay = form.querySelector('.js-delete-overlay');

    const handleOverlay = () => {
        deleteOverlay.classList.toggle('is-active');
    }

    deleteOverlayTriggers.forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            handleOverlay();
        })
    })
}

export default initDetailDelete;